import React, { useEffect, useState } from 'react'
import { COLORES } from '../../../config/colores'
import { Dialog, Button } from '@material-ui/core'
import DialogView from '../../Dialogos/DialogView'
import TablaCamionesEntrePlayaCalado from '../../Tablas/camionesEntrePlayaCalado/containers/TablaCamionesEntrePlayaCalado'
import CantidadProductosPorCereal from './reporteCamiones/CantidadProductosPorCereal'
import InfoAutodescargables from './reporteCamiones/InfoAutodescargables'

function ReporteEnTransitoPlayaCalado (props) {
  const { cpaEntrePlayaCalado, dialogOpen = () => {}, cortesPedidos } = props
  const [open, setOpen] = useState(false)
  const [totalProductos, setTotalProductos] = useState(null)
  const [productosPorCereal, setProductosPorCereal] = useState([])
  const [autodescargables, setAutodescargables] = useState([])

  useEffect(() => {
    if (cpaEntrePlayaCalado.length > 0) {
      const total = cpaEntrePlayaCalado.length
      setTotalProductos(total)

      const camAutodescargables = cpaEntrePlayaCalado.filter((c) => c.autodescargable)

      const productos = []
      const productosEnTransito = cpaEntrePlayaCalado.reduce((prod, camion) => {
        const { claveCereal } = camion
        let corte = []
        if (cortesPedidos && cortesPedidos.length > 0) {
          corte = cortesPedidos.filter(c => c.cereal.trim() === claveCereal.trim())
        }
        const productoExistente = productos.find(producto => producto.cereal === claveCereal)
        if (!productoExistente) {
          const cantidad = cpaEntrePlayaCalado.filter((p) => p.claveCereal === claveCereal)
          productos.push({ cereal: claveCereal, cantidad: cantidad.length, productoCortado: (corte && corte.length > 0) })
        }

        return productos
      }, [])

      setProductosPorCereal(productosEnTransito)
      setAutodescargables(camAutodescargables)

      productosEnTransito.sort((a, b) => {
        return a.cereal.localeCompare(b.cereal)
      })
    }
  }, [cpaEntrePlayaCalado, cortesPedidos])

  const handleClose = () => {
    setOpen(false)
    dialogOpen(true)
  }

  const handleOpen = () => {
    setOpen(true)
    dialogOpen(true)
  }

  const contenidoAutodescargables = () => {
    const filtroInicial = [
      {
        name: 'autodescargable',
        filterList: ['Si']
      }
    ]

    return <TablaCamionesEntrePlayaCalado filtroInicial={filtroInicial} />
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='xl'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Camiones entre playa y calado'
          content={<TablaCamionesEntrePlayaCalado />}
        />
      </Dialog>

      <CantidadProductosPorCereal
        productosPorCereal={productosPorCereal}
        titulo='Entre playa y calado'
        tituloTotal='Total en tránsito'
        totalProductos={totalProductos}
        cortes
      />

      { autodescargables &&
        <InfoAutodescargables
          productos={autodescargables}
          contenido={contenidoAutodescargables}
          titulo='Camiones autodescargables'
        />
      }
      <Button
        size='small'
        className='btn-reportes-bruto'
        variant='contained'
        style={{ color: '#ffffff', backgroundColor: COLORES.grey.dark, borderRadius: '22px', margin: '0 auto' }}
        onClick={handleOpen}
      >

            Entre playa y calado
      </Button>

    </>
  )
}

export default ReporteEnTransitoPlayaCalado
